var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_6456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13996 0 0 3.14027 0 7C0 10.8597 3.13996 14 7 14C10.86 14 14 10.8597 14 7C14 3.14027 10.86 0 7 0ZM9.7828 7.24525L5.69948 9.87025C5.65245 9.90061 5.59765 9.91673 5.54168 9.91668C5.49382 9.91668 5.4454 9.9047 5.40211 9.88107C5.35606 9.85603 5.31763 9.81902 5.29085 9.77395C5.26408 9.72888 5.24997 9.67742 5.25 9.625V4.375C5.25 4.2682 5.30811 4.1702 5.40211 4.11893C5.4944 4.06823 5.61004 4.07135 5.69948 4.12975L9.7828 6.75475C9.86598 6.80829 9.91668 6.90088 9.91668 7C9.91668 7.09912 9.86598 7.19168 9.7828 7.24525Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_6456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchIcon);
export default __webpack_public_path__ + "static/media/PitchIcon.46f1a116a4500e16d327501f13202011.svg";
export { ForwardRef as ReactComponent };